import React from "react";
import { baseUrl } from "../../api/Client";
import Card from "../../components/Card";


export default function DrinkCard({ drink, onEdit, onDelete, onFilter }) {
  return (
    <Card
      avatar={`${baseUrl}/img/drinkIcon/${drink.id}/100/100`}
      title={drink.nameBr}
      status={{
        label: drink.enabled ? "Ativo" : "Inativo",
        color: drink.enabled ? "green-400" : "disabled",
      }}
      onEdit={onEdit}
      onDelete={onDelete}
      onFilter={onFilter}
    >
      <p>{`ID: ${drink.id}`}</p>
      <p>{drink.locked ? "Não liberado" : "Liberado"}</p>
    </Card>
  );
}
